import { render, staticRenderFns } from "./BaseInfoModal.vue?vue&type=template&id=1e902c98&scoped=true&"
import script from "./BaseInfoModal.vue?vue&type=script&lang=js&"
export * from "./BaseInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./BaseInfoModal.vue?vue&type=style&index=0&id=1e902c98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e902c98",
  null
  
)

export default component.exports